var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h2", { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" }, [
        _vm._v("General Support"),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
        _c("li", { staticClass: "mb-2" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://help.letsreimagine.org/hc/en-us/sections/360008452032-Reimagine-Life-Loss-Love-Starter-Guide",
              },
            },
            [_vm._v("Collaborator Starter Guide")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mb-2" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://help.letsreimagine.org/hc/en-us/sections/360008512372--Marketing-your-events-and-resources",
              },
            },
            [_vm._v("Marketing Guide")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mb-2" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://help.letsreimagine.org/hc/en-us/sections/360008512392-Webinar-recordings-and-decks",
              },
            },
            [_vm._v("Webinar Recordings & Decks")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mb-2" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://www.facebook.com/groups/reimaginecollaborators",
              },
            },
            [_vm._v("Collaborator Facebook Group")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mb-2" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://help.letsreimagine.org/hc/en-us/sections/360008612391-Event-day-and-beyond",
              },
            },
            [_vm._v("Event Day and Beyond")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" }, [
        _vm._v("Additional Support"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-5" }, [
        _vm._v("First, visit our "),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/",
            },
          },
          [_vm._v("Help Center")]
        ),
        _vm._v("."),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-10" }, [
        _vm._v("Can't find what you're looking for?"),
        _c("br"),
        _vm._v(" Email "),
        _c("a", { attrs: { href: "mailto:hello@letsreimagine.org" } }, [
          _vm._v("hello@letsreimagine.org"),
        ]),
        _vm._v("."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }